import { config } from 'config';

const redirectToAuth = () => {
  window.open(`${config.appDomain}/auth?r=${window.location.href}`, '_self');
};

export default redirectToAuth;
